import React from 'react';

export const Loading = () => <div className="gooey">
<span className="dot"></span>
<div className="dots">
  <span></span>
  <span></span>
  <span></span>
</div>
</div>